export default {
      id: "icon--adren-tubing-usage",
      viewBox: "0 0 31.5 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--adren-tubing-usage",
      toString: function () {
        return this.url;
      }
    }